import { apiFetch } from 'services/apiClient';

/** Save with the pre-16 October workflow, exclusively for the planning detail page. */
export const savePlanningDetail = (data: any): Promise<any> =>
  apiFetch('/inspection-appointments/planning-detail/plan', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
